import {
  Avatar,
  Card as MuiCard,
  CardActionArea,
  IconButton,
  MenuItem,
  MenuList,
  Popover,
} from '@material-ui/core'
import { MoreVert, LockOpen } from '@material-ui/icons'
import { DialogConfirm } from 'components/DialogConfirm'
import { usePopup } from 'hooks/usePopup'
import { ISeparators } from 'interfaces/ISeparator'
import { enRules } from 'interfaces/IUser'
import React, { memo, useState, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { authenticationService } from 'services/authenticationService'
import { IState } from 'store'
import { stringAvatar, stringToColor } from 'utils'

import { useStyles } from './styles'

export const Card = ({ username, id }: ISeparators) => {
  const classes = useStyles()
  const navigate = useNavigate()
  const { addPopup } = usePopup()
  const [openMenu, setOpenMenu] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const anchorRef = useRef<HTMLButtonElement>(null)

  const { userPermissions } = useSelector<IState, IState>(state => state).user
  const canResetBlock = userPermissions.includes(enRules.Admin)

  const handleNavigate = () => {
    navigate(`../usuario/${id}`)
  }

  const handleMenuToggle = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    setOpenMenu(prevOpen => !prevOpen)
  }

  const handleMenuClose = (event: React.MouseEvent<Document, MouseEvent>) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return
    }
    setOpenMenu(false)
  }

  const handleResetBlock = (event: React.MouseEvent<HTMLLIElement>) => {
    event.stopPropagation()
    setOpenMenu(false)
    setOpenDialog(true)
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
  }

  const handleConfirmReset = async () => {
    try {
      await authenticationService.patchResetBlock(id)
      addPopup({
        type: 'success',
        title: 'Bloqueio resetado com sucesso',
      })
    } catch (error) {
      addPopup({
        type: 'error',
        title: 'Erro ao resetar bloqueio',
      })
    }
    handleCloseDialog()
  }

  const dialogText = `Você está prestes a resetar o tempo de bloqueio de login para o usuário ${username}. Esta ação removerá qualquer período restante de bloqueio, permitindo que o usuário tente fazer login imediatamente. Confirma o reset do tempo de bloqueio`

  return (
    <>
      <MuiCard className={classes.root}>
        <CardActionArea className={classes.content} onClick={handleNavigate}>
          <Avatar className={classes.avatar} style={{ background: stringToColor(username) }}>
            {stringAvatar(username)}
          </Avatar>
          <strong className={classes.name}>{username}</strong>
        </CardActionArea>

        {canResetBlock && (
          <div className={classes.options}>
            <IconButton
              ref={anchorRef}
              aria-controls={openMenu ? 'menu-list-grow' : undefined}
              aria-haspopup="true"
              onClick={handleMenuToggle}
              size="medium"
            >
              <MoreVert />
            </IconButton>

            <Popover
              open={openMenu}
              anchorEl={anchorRef.current}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              <MenuList autoFocusItem={openMenu} id="menu-list-grow">
                <MenuItem onClick={handleResetBlock} className={classes.menuAction}>
                  <LockOpen style={{ marginRight: '8px', fontSize: '1rem' }} />
                  Resetar bloqueio
                </MenuItem>
              </MenuList>
            </Popover>
          </div>
        )}
      </MuiCard>

      <DialogConfirm
        open={openDialog}
        handleClose={handleCloseDialog}
        initialState={false}
        confirm={handleConfirmReset}
        text={dialogText}
      />
    </>
  )
}

const CardOperator = memo(Card, (prevProps, nextProps) => {
  return prevProps.id === nextProps.id
})

export { CardOperator }
